import { Controller } from 'stimulus';
import scrollIntoView from '../scroll_parent_to_child';

function isVisible(el) {
  return el.dataset.visible === 'true';
}

function appendChild(parent, child) {
  parent.appendChild(child);
  return parent;
}

export default class extends Controller {
  static targets = ['main', 'buttons', 'template', 'anchor'];

  newButton() {
    return this.templateTarget.content.children[0].cloneNode(true);
  }

  buttonBuilder(anchor) {
    const button = this.newButton();
    button.dataset.target = '';
    button.classList.toggle(this.data.get('activeTab'), `#${anchor.id}` === this.data.get('selected'));
    button.textContent = anchor.dataset.title;
    button.dataset.anchor = anchor.id;
    return button;
  }

  connect() {
    this.updateButtons();
  }

  changeTab(event) { // eslint-disable-line class-methods-use-this
    const { target: { dataset: { anchor } = {} } } = event;
    const selector = `#${anchor}`;
    const target = this.mainTarget.querySelector(selector);
    if (target) {
      scrollIntoView(this.mainTarget, target);
      this.data.set('selected', selector);
      this.updateButtons();
    }
  }

  updateButtons() {
    if (!this.hasButtonsTarget) return;

    const buttons = document.createElement('span');
    const anchors = this.anchorTargets.filter(isVisible).map(this.buttonBuilder.bind(this));
    if (!this.data.get('selected')) anchors[0].classList.add(this.data.get('activeTab'));
    anchors.reduce(appendChild, buttons);
    this.buttonsTarget.innerHTML = '';
    this.buttonsTarget.appendChild(buttons);
  }

  get target() { // eslint-disable-line class-methods-use-this
    if (!window.location.hash) return undefined;

    return this.mainTarget.querySelector(window.location.hash);
  }
}
